import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 首页数据展示
	**/
	homeData() {
		return request({
	    url: baseUrl + '/dasboard/index',
	    method: 'GET'
	  })
	},
	/**
	 * 路灯列表
	**/
	homeLampListData() {
		return request({
	    url: baseUrl + '/device/getLamp',
	    method: 'GET'
	  })
	},
	/**
	 * 空气检测详情
	 * @param {lampId} 路灯id
	**/
	homeLampData(id) {
		return request({
	    url: baseUrl + '/device/listpie/'+id,
	    method: 'GET'
	  })
	},
}